import { SET_CURRENT_TEAM, SET_TIMER, BUZZ_INFO } from "./actions";

const defaultState = {
  currentTeam: "",
  teamAquaterBack: {},
  teamBquaterBack: {},
  timer: 60,
};

const game3Reducer = (state = defaultState, action) => {
  switch (action.type) {
    case SET_CURRENT_TEAM: {
      return {
        ...state,
        currentTeam: action.data.currentTeam,
        teamAquaterBack: action.data.teamAquaterBack,
        teamBquaterBack: action.data.teamBquaterBack,
      };
    }

    case SET_TIMER: {
      return {
        ...state,
        timer: action.data,
      };
    }

    case BUZZ_INFO: {
      return {
        ...state,
        ...action.data,
      };
    }

    default:
      return state;
  }
};

export default game3Reducer;
